import React from 'react'
import { Box, Typography } from '@mui/material'
import MapIcon from '@mui/icons-material/Map'
import NatureIcon from '@mui/icons-material/Nature'
import StraightenIcon from '@mui/icons-material/Straighten'
import HealthAndSafetyIcon from '@mui/icons-material/HealthAndSafety'
import WarningIcon from '@mui/icons-material/Warning'
import AssignmentIcon from '@mui/icons-material/Assignment'
import CheckCircleIcon from '@mui/icons-material/CheckCircle'

const ICONS = [
    MapIcon,
    NatureIcon,
    StraightenIcon,
    HealthAndSafetyIcon,
    WarningIcon,
    AssignmentIcon,
]

const WizardProgressMobile = ({
    steps,
    activeStep,
    totalSteps,
    onStepClick,
    completedSteps,
}) => {
    return (
        <Box sx={{ width: '100%', px: 2, py: 2, bgcolor: 'background.paper' }}>

            {/* Progress Bar Line */}
            <Box
                sx={{
                    position: 'relative',
                    mb: 3,
                    height: 8,
                    bgcolor: 'action.hover',
                    borderRadius: 4,
                    overflow: 'hidden',
                }}>
                <Box
                    sx={{
                        height: '100%',
                        bgcolor: 'primary.main',
                        transition: 'width 0.3s ease-out',
                        width: `${((activeStep) / (totalSteps - 1)) * 100}%`,
                    }}
                />
                <Typography
                    variant="caption"
                    sx={{
                        position: 'absolute',
                        right: 0,
                        top: -20,
                        fontWeight: 500,
                        color: 'text.secondary',
                    }}>
                    {activeStep + 1} de {totalSteps}
                </Typography>
            </Box>

            {/* Steps Icons */}
            <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                {steps.map((step, index) => {
                    const Icon = ICONS[index % ICONS.length]
                    const isCompleted = completedSteps[index]
                    const isCurrent = index === activeStep

                    return (
                        <Box
                            key={step.label}
                            onClick={() => onStepClick(index)}
                            sx={{
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                gap: 0.5,
                                cursor: 'pointer',
                                transition: 'all 0.2s',
                            }}>
                            <Box
                                sx={{
                                    width: 40,
                                    height: 40,
                                    borderRadius: '50%',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    border: 2,
                                    transition: 'all 0.2s',
                                    bgcolor: isCurrent
                                        ? 'primary.main'
                                        : isCompleted
                                            ? 'transparent'
                                            : 'action.hover',
                                    borderColor: isCurrent || isCompleted ? 'primary.main' : 'transparent',
                                    color: isCurrent
                                        ? 'primary.contrastText'
                                        : isCompleted
                                            ? 'primary.main'
                                            : 'text.disabled',
                                    transform: isCurrent ? 'scale(1.1)' : 'scale(1)',
                                    boxShadow: isCurrent ? 3 : 0,
                                }}>
                                {isCompleted && !isCurrent
                                    ? <CheckCircleIcon fontSize="small" />
                                    : <Icon fontSize="small" />}
                            </Box>
                            <Typography
                                variant="caption"
                                sx={{
                                    display: { xs: 'none', sm: 'block' },
                                    fontWeight: 500,
                                    color: isCurrent ? 'primary.main' : 'text.secondary',
                                }}>
                                {step.label}
                            </Typography>
                        </Box>
                    )
                })}
            </Box>
        </Box>
    )
}

export default WizardProgressMobile
